//hotpoints //elementy hover nia mają mieć satystyk ga360

$('.hotpoints').find('.hotpoints--poi').on('hover touchend',function(){
    var current = $(this).index();
    if(!$(this).hasClass('__jsActive')) {
        $(this).parents('.hotpoints').find('.hotpoints--poi').removeClass('__jsActive');
        $(this).parents('.hotpoints').find('.hotpoints--desc').removeClass('__jsActive');
        $(this).addClass('__jsActive');
        $(this).parents('.hotpoints').find('.hotpoints--desc').eq($(this).index()).addClass('__jsActive');
        
        $(this).parents('.hotpoints').find('.hotpoints--mobile').addClass('__jsActive');
        
        sendStats('hotpoint', 'hotpoint-'+current, '');
        if($(this).parents('.hotpoints').find('.hotpoints--mobile') && $(this).parents('.hotpoints').find('.hotpoints--mobile').outerHeight() != 0 ){
            console.log('to już');
            var txt = $(this).parents('.hotpoints').find('.hotpoints--poi-txt').eq($(this).index()).html();
            $(this).parents('.hotpoints').find('.hotpoints--mobile').text(txt);  
        } else { console.log('not yet'); }
    }
    else {
        
    }
});